import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from '@/router'
import store from '@/store'
const API_URL = process.env.API_URL || 'http://localhost:3000/api'
axios.defaults.baseURL = API_URL
axios.defaults.headers = {
  'Content-Type': 'application/json',
  'Authorization': 'Bearer ' + localStorage.token
}

axios.interceptors.response.use(
  null,
  error => errorHandler(error)
)

const errorHandler = (error) => {
  if (error.response && error.response.status === 401) {
    delete localStorage.token
    store.commit('logout')
    router.push('/')
  }
  return Promise.reject(error)
}

export default axios

Vue.use(VueAxios, axios)



// WEBPACK FOOTER //
// ./src/backend/index.js